export enum ContactPreferenceType {
    PrivacyPreference = 19,
    Email = 20,
    Phone = 21,
    NotifyMe = 22,
    MyRetailSiteEmail = 23,
    MyretailSitePhone = 24,
    Registered_Name = 26,
    Business_Name = 27,
    SaveSelection = 28,
    dontRemindKyc =29
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/contact-preference-type.enum.ts